import React from 'react';
import styled from 'styled-components';
import { INormalizedImage } from '@hotelplan/components.common.image';
import { InfoNotification } from '@hotelplan/components.common.notifications';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { Container } from 'components/core/container';
import { useGetInfoNotificationQuery } from 'graphql/notifications/GetInfoNotification.generated';

const NotificationInfoContainer = styled.div(
  sx2CssThemeFn({
    borderBottom: '1px solid',
    borderColor: 'lightGreyFirst',
    backgroundColor: 'white',
  })
);

const InfoNotificationBanner = () => {
  const { data } = useGetInfoNotificationQuery({});

  const mainText = data?.notificationInfoData.mainText;

  // @todo: remove as casting
  const icon = data?.notificationInfoData.icon as INormalizedImage;

  return mainText ? (
    <NotificationInfoContainer>
      <Container>
        <InfoNotification mainText={mainText} icon={icon} />
      </Container>
    </NotificationInfoContainer>
  ) : null;
};

export default React.memo(InfoNotificationBanner);
